import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';
import {
  ConnectedRouter,
  connectRouter,
  routerMiddleware
} from 'connected-react-router';
import * as storage from 'redux-storage';
import createEngine from 'redux-storage-engine-localstorage';
import debounce from 'redux-storage-decorator-debounce';
import filter from 'redux-storage-decorator-filter';
import { reducer as formReducer } from 'redux-form';
import Modal from 'react-modal';

// Polyfills for IE11 support.
import 'core-js/es6/symbol'; // needed for youtube-player
import 'core-js/fn/symbol/iterator'; // needed for youtube-player
import 'core-js/fn/object/assign';
import 'core-js/fn/object/keys';
import 'core-js/fn/object/values';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/filter';
import 'core-js/fn/array/for-each';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/map';
import 'core-js/fn/array/reduce';
import 'core-js/fn/array/some';

import config from './config';
import reducers from './reducers';
import api from './api';

// import ErrorBoundary from './components/ErrorBoundary';
import App from './containers/App';
import register from './registerServiceWorker';
import ScrollToTop from './components/ScrollToTop';

import './index.css';

Modal.setAppElement('#root');

const options = config.basename ? { basename: config.basename } : {};
const history = createBrowserHistory(options);
const routerHistoryMiddleware = routerMiddleware(history);
const engine = debounce(
  filter(createEngine(config.storage.key), null, [
    'router', // don't persist the route location in storage
    'ui',
    'questions',
    'visitationRecords',
    'growthRecords',
    'comfortRecords',
    'bathingRecords',
    'form.EmailEditForm',
    'form.PasswordEditForm',
    'form.PinEditForm',
    'content',
    ...Object.keys(api.reducers)
  ]),
  config.storage.frequency
);
const storageMiddleware = storage.createMiddleware(engine);

const rootReducer = storage.reducer(
  combineReducers({
    ...reducers,
    ...api.reducers,
    form: formReducer,
    router: connectRouter(history)
  })
);

const store = createStore(
  rootReducer,
  process.env.NODE_ENV === 'development' &&
  window.__REDUX_DEVTOOLS_EXTENSION__ && // eslint-disable-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line no-underscore-dangle
  applyMiddleware(routerHistoryMiddleware, thunkMiddleware, storageMiddleware)
);

const load = storage.createLoader(engine);
load(store).then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );

  register();
});



// WEBPACK FOOTER //
// ./src/index.js